<template>
  <div class="row">
    <div class="col-md-12 pad-to-5">
    <!--   <router-link class="btn btn-orange" title="Back to settings" :to="{ path: '/settings'}"><i class="ti-arrow-left"></i> Back</router-link> -->
      <p></p>
      <product-options-form :route="route" @on-submit="onUserSubmit" :kdsSectionsParent="kdsSections"></product-options-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import ProductOptionsForm from './ProductOptionsForm.vue'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      ProductOptionsForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        productOptionsForm: {},
        modelValidations: {
          required: {
            required: true
          }
        },
        kdsSections: []
      }
    },
    created () {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      this.apiRequest('/sections', 'GET', data, (response) => {
        if (response.status) {
          this.kdsSections = response.data
        }
      })
    },
    methods: {
      onUserSubmit (model, isValid) {
        this.productOptionsForm = model
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/ProductOptions/ProductOptionsEdit.vue